<form [formGroup]="form" (ngSubmit)="onSaveRequested()" class="max-w-[98%] mx-auto">
  <div class="change-password-container">
    @if (dashboardRoute) {
      <a
        class="return-dashboard-button focus:outline-none focus:ring-4 focus:ring-blue-300"
        [routerLink]="['/', dashboardRoute]">
        <mat-icon>arrow_back</mat-icon>
        <span>Return to Dashboard</span>
      </a>
    }
    @if (showChangePasswordButton) {
      <button
        class="change-password-button focus:outline-none focus:ring-4 focus:ring-blue-300"
        type="button"
        (click)="onChangePasswordRequested()">
        Change Password
      </button>
    }
  </div>

  <mat-card class="personal-details-container overflow-x-auto w-full mt-1 mb-8 border-2 p-4 ml-auto mr-auto bg-white rounded-lg">
    <mat-card-content>
      <div class="mt-2 mb-4">
        <p class="text-2xl mb-2 font-bold">{{ sectionTitle }}</p>
        <hr class="bg-green h-[3px] border-none">
      </div>

      <div class="grid grid-cols-1 md:grid-cols-4 gap-8">
        <div class="col-span-1">
          <label for="firstName" class="form-label">First Name</label>
          <mat-form-field appearance="outline">
            <input id="firstName" matInput formControlName="firstName" required>
            @if (form.get('firstName')?.hasError('required')) {
              <mat-error>First Name is required.</mat-error>
            }
          </mat-form-field>
        </div>

        <div class="col-span-1">
          <label for="lastName" class="form-label">Last Name</label>
          <mat-form-field appearance="outline">
            <input id="lastName" matInput formControlName="lastName" required>
            @if (form.get('lastName')?.hasError('required')) {
              <mat-error>Last Name is required.</mat-error>
            }
          </mat-form-field>
        </div>

        <div class="col-span-1">
          <label for="email" class="form-label">Email Address</label>
          <mat-form-field appearance="outline">
            <input id="email" matInput formControlName="email" required email>
            @if (form.get('email')?.hasError('required')) {
              <mat-error>Email is required.</mat-error>
            }
            @if (form.get('email')?.hasError('email')) {
              <mat-error>Please enter a valid email address.</mat-error>
            }
          </mat-form-field>
        </div>

        <div class="col-span-1">
          <label for="phone" class="form-label">Phone Number</label>
          <mat-form-field appearance="outline">
            @if (phoneMask) {
              <input id="phone" matInput [mask]="phoneMask" formControlName="phone" type="tel" placeholder="(123) 456-7890" required>
            } @else {
              <input id="phone" matInput formControlName="phone" type="tel" placeholder="(123) 456-7890" required>
            }
            @if (form.get('phone')?.hasError('required')) {
              <mat-error>Phone Number is required.</mat-error>
            }
            @if (form.get('phone')?.hasError(phoneValidationErrorKey)) {
              <mat-error>{{ phoneValidationErrorText }}</mat-error>
            }
          </mat-form-field>
        </div>

        @if (showJobTitleField) {
          <div class="col-span-1">
            <label for="jobTitle" class="form-label">Job Title</label>
            <mat-form-field appearance="outline">
              <input id="jobTitle" matInput formControlName="jobTitle" required>
              @if (form.get('jobTitle')?.hasError('required')) {
                <mat-error>Job Title is required.</mat-error>
              }
            </mat-form-field>
          </div>
        }

        @if (showFaxNumberField) {
          <div class="col-span-1">
            <label for="faxNumber" class="form-label">Fax Number</label>
            <mat-form-field appearance="outline">
              <input id="faxNumber" matInput formControlName="faxNumber" type="tel" placeholder="(123) 456-7890">
              @if (form.get('faxNumber')?.hasError('pattern')) {
                <mat-error>Please enter a 10-digit fax number.</mat-error>
              }
            </mat-form-field>
          </div>
        }

        @if (showAddressFields) {
          <div class="col-span-1 md:col-span-2">
            <label for="address1" class="form-label">Street Address</label>
            <mat-form-field appearance="outline">
              <input id="address1" matInput formControlName="address1" required>
              @if (form.get('address1')?.hasError('required')) {
                <mat-error>Street Address is required.</mat-error>
              }
            </mat-form-field>
          </div>

          <div></div>

          <div class="col-span-1">
            <label for="city" class="form-label">City</label>
            <mat-form-field appearance="outline">
              <input id="city" matInput formControlName="city" required>
              @if (form.get('city')?.hasError('required')) {
                <mat-error>City is required.</mat-error>
              }
            </mat-form-field>
          </div>

          <div class="col-span-1">
            <label for="state" class="form-label">State</label>
            <mat-form-field appearance="outline">
              <mat-select id="state" formControlName="state" required>
                @for (state of stateOptions; track state.value) {
                  <mat-option [value]="state.value">{{ state.label }}</mat-option>
                }
              </mat-select>
              @if (form.get('state')?.hasError('required')) {
                <mat-error>State is required.</mat-error>
              }
            </mat-form-field>
          </div>

          <div class="col-span-1">
            <label for="postalCode" class="form-label">Zip Code</label>
            <mat-form-field appearance="outline">
              <input
                id="postalCode"
                matInput
                formControlName="postalCode"
                required
                appWholeNumbersOnly
                type="text"
                inputmode="numeric"
                pattern="\d*"
                maxlength="5">
              @if (form.get('postalCode')?.hasError('required')) {
                <mat-error>Zip Code is required.</mat-error>
              }
              @if (form.get('postalCode')?.hasError('pattern')) {
                <mat-error>Zip Code must be 5 digits</mat-error>
              }
            </mat-form-field>
          </div>
        }
      </div>

      @if (form.dirty) {
        <div class="flex justify-end space-x-4">
          <button class="text-gray-800 bg-gray-300 hover:bg-gray-400 disabled:opacity-60 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none"
                  style="margin-right: 5px;"
                  type="button"
                  (click)="onCancelRequested()"
          >Cancel
          </button>
          <button class="text-white bg-black hover:bg-blue-800 disabled:opacity-60 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none"
                  type="submit">Save
          </button>
        </div>
      }
    </mat-card-content>
  </mat-card>
</form>
